import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import './Pages.css';

function Terms() {
  return (
    <div className="Page">
      <PageHeader />
      <div className="Page-container">
        <h1>Terms of Service</h1>

        <div className="Page-section">
          <h3>1. Acceptance of Terms</h3>
          <p>
            Welcome to the website of Cybersmith.io Inc. ("Company", "we", "our," or "us"). By accessing or using our website (the "Site"), you agree to comply with and be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, please do not use the Site.
          </p>

          <h3>2. Modification of Terms</h3>
          <p>
            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the Site following any changes constitutes your acceptance of the revised Terms.
          </p>


          <h3>3. Intellectual Property Rights</h3>
          <p>
            All content on the Site, including text, graphics, logos, images, and software, is the property of Cybersmith.io Inc or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or modify any content without our prior written consent.
          </p>

          <h3>4. Use Of Site</h3>
          <p>
            You agree to use the Site for lawful purposes only. You shall not:
          </p>
          <ul>
            <li>Engage in any activity that violates applicable laws or regulations.</li>
            <li>Use the Site to transmit unauthorized or harmful content.</li>
            <li>Attempt to gain unauthorized access to any part of the Site or its related systems.</li>
          </ul>

          <h3>5. Disclaimer of Warranties</h3>
          <p>
The Site is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee the accuracy, reliability, or completeness of the Site’s content and disclaim all warranties, including but not limited to merchantability, fitness for a particular purpose, and non-infringement.
          </p>

          <h3>6. Limitation Of Liability</h3>
          <p>
To the fullest extent permitted by law, Cybersmith.io Inc. shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of or inability to use the Site, even if advised of the possibility of such damages.
          </p>

          <h3>7. Third-Party Links</h3>
          <p>
The Site may contain links to third-party websites for convenience. We do not endorse or assume responsibility for any content, products, or services offered by third parties.          
</p>

          <h3>8. Indemnification</h3>
          <p>
You agree to indemnify and hold harmless Cybersmith.io Inc, its affiliates, officers, directors, employees, and agents from any claims, damages, or expenses (including legal fees) arising from your use of the Site or violation of these Terms.
</p>

          <h3>9. Governing Law And Jurisdiction</h3>
          <p>
These Terms shall be governed by and construed in accordance with the laws of Ontario, Canada, without regard to its conflict of law principles. Any disputes arising under these Terms shall be resolved exclusively in the courts located in Ontario, Canada.</p>

          <h3>10. Use Of AI</h3>
          <p>The article content on this site is NOT generated by artificial intelligence.  
            All article content is written by humans alone.  
            Images used on this site may be generated by artificial intelligence.
          </p>


        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
